import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  pure: true
})
export class ReplacePipe implements PipeTransform {

  transform(value: any): any {
    if(value) {
      value = value.replace('&amp;','&');
      return value.replace(/[\s&/]+/g, '-');
    }
    
  }

}
